import React, { useState } from 'react'
import { Player } from "video-react";
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap';

const Information = () => {
    const { t } = useTranslation()

    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);

    return (
        <>
            <section className="information-section">
                <div className="first-para" style={{ margin: "0" }}>
                    <h2>{t('Dop-detail4')} <span></span></h2>
                    <p>{t('an1')}
                    </p>
                    <p>{t('an2')}</p>
                </div>
                <div className="first-para">
                    <h2>{t('an3')} <span></span></h2>
                    <p>{t('an4')}</p>
                </div>
                <div className="first-para">
                    <h2>{t('an5')} <span></span></h2>
                    <p>{t('an6')}</p>
                </div>
                <div className="first-para">
                    <h2>{t('an7')}<span></span></h2>
                    <p>{t('an8')}  </p>
                    <p>{t('an9')}</p>
                </div>
                <div className="first-para">
                    <h2>{t('an10')}<span></span></h2>
                    <p>{t('an11')}  </p>
                    <p>{t('an12')}</p>
                </div>
                <div className="first-para">
                    <h2>{t('an13')}<span></span></h2>
                    <p>{t('an14')}  </p>
                </div>

                <div className="first-para">
                    <h2>{t('Inc-detailt34')} <span></span></h2>
                    <div className="team-gems">
                        <div className="single-team">
                            <img src="\assets\alldetailpages\astra\info\team\asshar.png" alt="img" className='img-fluid' />
                            <h6>{t('an15')} </h6>
                            <h5>{t('an16')}</h5>
                            <p>{t('an17')}</p>
                        </div>
                        <div className="single-team">
                            <img src="\assets\alldetailpages\astra\info\team\faizy.png" alt="img" className='img-fluid' />
                            <h6>{t('an18')} </h6>
                            <h5>{t('an19')}</h5>
                            <p>{t('an20')}
                            </p>
                        </div>
                        <div className="single-team">
                            <img src="\assets\alldetailpages\astra\info\team\ben.png" alt="img" className='img-fluid' style={{ objectPosition: "50%" }} />
                            <h6>{t('an21')} </h6>
                            <h5>{t('an22')}</h5>
                            <p>{t('an23')}</p>
                        </div>
                        <div className="single-team">
                            <img src="\assets\alldetailpages\astra\info\team\sarah.png" alt="img" className='img-fluid' style={{ objectPosition: "50%" }} />
                            <h6>{t('an24')}</h6>
                            <h5>{t('an25')}</h5>
                            <p>{t('an26')}</p>
                        </div>
                        <div className="single-team">
                            <img src="\assets\alldetailpages\astra\info\team\dr.png" alt="img" className='img-fluid' style={{ objectPosition: "50%" }} />
                            <h6>{t('an27')} </h6>
                            <h5>{t('an28')}</h5>
                            <p>{t('an29')}</p>
                        </div>
                    </div>

                </div>
                <div className="first-para">
                    <h2>{t('Dop-detail31')} <span></span></h2>
                    <div className="twice-tokenomics">
                        <div className="tokenomic-img" onClick={() => {setShow1(true)}} style={{cursor: "pointer"}}>
                            <img src="\assets\alldetailpages\astra\info\tokenomics.png" alt="img" className='img-fluid' />
                            {/* <img src="\assets\alldetailpages\astra\info\tokenomics-light.png" alt="img" className='img-fluid d-none show-in-light-theme ' /> */}
                        </div>
                    </div>
                </div>



            </section>

            <Modal className='common-modal-style image-preview distribution-modl' show={show1} onHide={handleClose1} centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body className='p-0'>
                    <img src="\assets\alldetailpages\astra\info\tokenomics.png" alt="img" className='img-fluid' />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Information
